export function getCrmContainerContentId(content) {
  return content.type === 'CONTAINER' ? content.id : content.definition.cardId;
}